<template>
   <div class="relative">
      <div class="flex flex-col md:flex-row items-center justify-between w-full gap-4">

         <div class="flex flex-row mb-2 w-full border-gray-400">
             <div class="shadow border  cursor-pointer bg-white  rounded-md flex flex-1 items-center p-4">

                 <div class="flex-1 flex-col space-y-8 pl-1 md:mr-16">
                     <div class="font-medium text-gray-700 text-xl">
                         Total Number of Students
                     </div>
                     <div class=" text-red-700 text-3xl font-semibold">
                         100
                     </div>
                 </div>
             </div>
         </div>
         <div class="flex flex-row mb-2 w-full border-gray-400">
             <div class="shadow border  cursor-pointer bg-white  rounded-md flex flex-1 items-center p-4">

                 <div class="flex-1 flex-col space-y-8 pl-1 md:mr-16">
                     <div class="font-medium text-gray-700 text-xl">
                         Total Number of Subjects
                     </div>
                     <div class=" text-red-700 text-3xl font-semibold">
                         100
                     </div>
                 </div>
             </div>
         </div>
         <div class="flex flex-row mb-2 w-full border-gray-400">
             <div class="shadow border  cursor-pointer bg-white  rounded-md flex flex-1 items-center p-4">

                 <div class="flex-1 flex-col space-y-8 pl-1 md:mr-16">
                     <div class="font-medium text-gray-700 text-xl">
                         Total Number of Staff
                     </div>
                     <div class=" text-red-700 text-3xl font-semibold">
                         100
                     </div>
                 </div>
             </div>
         </div>
        
     </div>

     <div class="overflow-x-scroll md:overflow-hidden  absolute w-full" style="max-width: 98vw">
      <table class="table p-4 bg-white rounded-lg shadow w-full mt-4 mb-28">
         <thead>
            <tr>
               <th class="border-2 p-4 text-lg font-bold ">
                  <span>Days/</span>
                  <span>Period</span>
               </th>
               <th class="border-2 p-4 text-lg font-bold text-center  whitespace-nowrap  ">
                  1st
               </th>
               <th class="border-2 p-4  whitespace-nowrap text-lg  font-bold text-center">
                  2nd
               </th>
               <th class="border-2 p-4  whitespace-nowrap text-lg font-bold text-center">
                  3rd
               </th>
               <th class="border-2  whitespace-nowrap text-lg font-bold text-center">
                  Short break
               </th>
               <th class="border-2 p-4  whitespace-nowrap text-lg font-bold text-center">
                  4th
               </th>
               <th class="border-2 p-4  whitespace-nowrap text-lg font-bold text-center">
                  5th
               </th>
               <th class="border-2  whitespace-nowrap text-lg font-bold text-center">
                  Long break
               </th>
               <th class="border-2 p-4  whitespace-nowrap text-lg font-bold text-center">
                  6th
               </th>
               <th class="border-2 p-4  whitespace-nowrap text-lg font-bold text-center">
                  7th
               </th>
               <th class="border-2 p-4  whitespace-nowrap text-lg font-bold text-center">
                  8th
               </th>
            </tr>
         </thead>
         <tbody>
            <tr>

               <td class="border-2 p-4  ">
                  Monday
               </td>
               <td class="border-2 p-4 text-center ">
                  Mathematics
               </td>
               <td class="border-2 p-4 text-center">
                  English
               </td>
               <td class="border-2 p-4 text-center">
                  Geography
               </td>
               <td class="border-2 p-4 text-center">

               </td>
               <td class="border-2 p-4 text-center">
                  Physics
               </td>
               <td class="border-2 p-4 text-center">
                  Chemistry
               </td>
               <td class="border-2 p-4 text-center">

               </td>
               <td class="border-2 p-4 text-center">
                  Literature
               </td>
               <td class="border-2 p-4 text-center">
                  Commerce
               </td>
               <td class="border-2 p-4 text-center">
                  Marketing
               </td>
            </tr>
            <tr>
               <td class="border-2 p-4  ">
                  Tuesday
               </td>
               <td class="border-2 p-4 text-center ">
                  Mathematics
               </td>
               <td class="border-2 p-4 text-center">
                  English
               </td>
               <td class="border-2 p-4 text-center">
                  Geography
               </td>
               <td class="border-2 p-4 text-center">

               </td>
               <td class="border-2 p-4 text-center">
                  Physics
               </td>
               <td class="border-2 p-4 text-center">
                  Chemistry
               </td>
               <td class="border-2 p-4 text-center">

               </td>
               <td class="border-2 p-4 text-center">
                  Literature
               </td>
               <td class="border-2 p-4 text-center">
                  Commerce
               </td>
               <td class="border-2 p-4 text-center">
                  Marketing
               </td>
            </tr>
            <tr>
               <td class="border-2 p-4  ">
                  Wednesday
               </td>
               <td class="border-2 p-4 text-center ">
                  Mathematics
               </td>
               <td class="border-2 p-4 text-center">
                  English
               </td>
               <td class="border-2 p-4 text-center">
                  Geography
               </td>
               <td class="border-2 p-4 text-center">

               </td>
               <td class="border-2 p-4 text-center">
                  Physics
               </td>
               <td class="border-2 p-4 text-center">
                  Chemistry
               </td>
               <td class="border-2 p-4 text-center">

               </td>
               <td class="border-2 p-4 text-center">
                  Literature
               </td>
               <td class="border-2 p-4 text-center">
                  Commerce
               </td>
               <td class="border-2 p-4 text-center">
                  Marketing
               </td>
            </tr>
            <tr>
               <td class="border-2 p-4  ">
                  Thursday
               </td>
               <td class="border-2 p-4 text-center ">
                  Mathematics
               </td>
               <td class="border-2 p-4 text-center">
                  English
               </td>
               <td class="border-2 p-4 text-center">
                  Geography
               </td>
               <td class="border-2 p-4 text-center">

               </td>
               <td class="border-2 p-4 text-center">
                  Physics
               </td>
               <td class="border-2 p-4 text-center">
                  Chemistry
               </td>
               <td class="border-2 p-4 text-center">

               </td>
               <td class="border-2 p-4 text-center">
                  Literature
               </td>
               <td class="border-2 p-4 text-center">
                  Commerce
               </td>
               <td class="border-2 p-4 text-center">
                  Marketing
               </td>
            </tr>
            <tr>
               <td class="border-2 p-4  ">
                  Friday
               </td>
               <td class="border-2 p-4 text-center ">
                  Mathematics
               </td>
               <td class="border-2 p-4 text-center">
                  English
               </td>
               <td class="border-2 p-4 text-center">
                  Geography
               </td>
               <td class="border-2 p-4 text-center">

               </td>
               <td class="border-2 p-4 text-center">
                  Physics
               </td>
               <td class="border-2 p-4 text-center">
                  Chemistry
               </td>
               <td class="border-2 p-4 text-center">

               </td>
               <td class="border-2 p-4 text-center">
                  Literature
               </td>
               <td class="border-2 p-4 text-center">
                  Commerce
               </td>
               <td class="border-2 p-4 text-center">
                  Marketing
               </td>
            </tr>

         </tbody>
      </table>

     </div>
      
   </div>

</template>

<script setup lang="ts">

</script>
